import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuItemIndexQuerySchema } from '~/services/api/generated'

const schema = MenuItemIndexQuerySchema.strict()

// ListMenuItemsRequest
export const MenuItemIndex = (_context: NoContext): z.ZodType<z.output<typeof schema>> => schema
